import { Typography } from '@mui/material';
import type { FC } from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { callIdSelector } from 'features/call/call-base/store/selectors';
import { ColdHandoffStatus } from 'features/cold-handoff/enums';
import { useColdHandoffSearchRnsHandlers } from 'features/cold-handoff/hooks';
import { ColdHandoffDaoService } from 'features/cold-handoff/services';
import {
  coldHandoffStatusSelector,
  resetColdHandoff,
} from 'features/cold-handoff/store';
import { CollaborationStepContainer } from 'features/collaboration-base/components';
import { handleError } from 'features/notification/store';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { Button } from 'features/ui/elements';

export const ColdHandoffSearch: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const callId = useAppSelector(callIdSelector);
  const status = useAppSelector(coldHandoffStatusSelector);
  useColdHandoffSearchRnsHandlers();

  const handleCancelRequest = useCallback(async () => {
    try {
      await ColdHandoffDaoService.cancelHandoff({
        callId,
      });
      dispatch(resetColdHandoff());
    } catch (error) {
      dispatch(
        handleError({
          error,
          methodName: 'handleCancelRequest',
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callId]);

  return (
    <>
      {status === ColdHandoffStatus.REQUESTED && (
        <CollaborationStepContainer testId='cold-handoff-search'>
          <Typography variant='body1' color={theme.palette.grey[50]}>
            {t('handoffSearchTitle')}
          </Typography>
          <Typography
            variant='body2'
            color={theme.palette.common.white}
            mt={8}
            lineHeight='24px'
          >
            {t('searchingNextInterpreter')}
          </Typography>
          <CancelButton
            size='small'
            color='secondary'
            title={t('cancel')}
            onClick={handleCancelRequest}
            autoFocus
          >
            {t('cancel')}
          </CancelButton>
        </CollaborationStepContainer>
      )}
    </>
  );
};

const CancelButton = styled(Button)`
  margin-top: ${theme.spacing(8)};
`;
